import * as types from './types';
import { actionBuilder } from './actions';
import { getValueFromRangeOrBase } from '../../../util/helpers';

/**
 * Must be function to create new object as Vuex modifies existing objects
 */
const defaultProduct = () => ({
  product: '',
  minAmount: 0,
  baseAmount: 0,
  maxAmount: 0,
  minPeriod: 0,
  basePeriod: 0,
  maxPeriod: 0,
  contractConclusionFee: 0,
  contractConclusionFeeRate: 0,
  maintenanceFee: 0,
  maintenanceFeeRate: 0,
  minContractConclusionFee: 0,
  maxContractConclusionFee: 0,
  minMonthlyPayment: 0,
  minInterestRate: 0,
  maxInterestRate: 0,
  interestRate: 0,
  maxMonthlyFee: 0,
  contractConclusionFeeFromProductAmount: 0,
});

const state = {
  products: [defaultProduct()],
  product: {
    productName: null,
    amount: null,
    interestRate: null,
    period: null,
    monthlyPayment: null,
  },
  loading: false,
};

export const mutations = {
  [types.SET_PRODUCTS]: (state, products) => {
    state.products = products;
  },
  [types.SET_PRODUCT]: (state, product) => {
    state.product.productName = product;
  },
  [types.SET_PRODUCT_DATA]: (state, { amount, period, productName, interestRate, monthlyPayment }) => {
    if (amount) {
      state.product.amount = Number(amount);
    }
    if (period) {
      state.product.period = Number(period);
    }
    if (interestRate) {
      state.product.interestRate = Number(interestRate);
    }
    if (productName) {
      state.product.productName = productName;
    }
    if (monthlyPayment) {
      state.product.monthlyPayment = monthlyPayment;
    }
  },
  [types.LOADING]: (state, loading) => {
    state.loading = loading;
  },
};

const getters = {
  products: state => state.products,
  isLoading: state => state.loading,
  getProductData: state => {
    // setting default product
    const productName = state.product.productName || state.products[0]?.product;
    let product = state.products.find(product => product.product === productName);
    if (!product) {
      // Expected flow when before products fetched and URL selects a non-default product
      product = defaultProduct();
    }

    return {
      ...product,
      amount: getValueFromRangeOrBase(state.product.amount, product.baseAmount, product.minAmount, product.maxAmount),
      interestRate: getValueFromRangeOrBase(state.product.interestRate, product.interestRate, product.minInterestRate, product.maxInterestRate),
      period: getValueFromRangeOrBase(state.product.period, product.basePeriod, product.minPeriod, product.maxPeriod),
      productName,
    };
  },
};

const moduleBuilder = (client, router) => {
  return {
    namespaced: true,
    state,
    actions: actionBuilder(client, router),
    getters,
    mutations,
  };
};

export default {
  moduleBuilder,
  types,
};
